import { useState } from "react";

import Menu from "../../components/Menu";
import More from '../../assets/img/mais.svg'
import Doctor from '../../assets/img/doctor-black.svg'
import Back from '../../assets/img/de-volta.svg'

import { Link } from 'react-router-dom'
import ListCardProcedures from "../../components/ListCardProcedures";
import { FlaskConical } from "lucide-react";

export default function ProceduresList() {
  const [search, setSearch] = useState("")

  const screenTela =
    <div className='screenContainer' style={{paddingRight:'0px'}}>
      <div className="row row-container">
        <h1 className="col-6 col-sm-6 col-lg-8 name-screen"> <FlaskConical size={40} /> <span className="name-screen-title name-screen-professionals " >Procedimentos</span> </h1>
        
        <div className="col-6 col-sm-6 col-lg-4 name-search name-search-2">
          <input value={search} onChange={(value) =>{
            setSearch(value.target.value)
          }} type="text" placeholder="Pesquisar Procedimento" className="form-control input-pesquisa" />
        </div>

          <ListCardProcedures search={search} />
      </div>

      <Link to="/dashboard">
        <div className="button-back-list">
          <img alt="mais" src={Back} />
        </div>
      </Link>
    </div>

  return (
    <Menu screen={screenTela} />
  )
}